import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, IconButton, Tooltip } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Select from '../Inputs/Select';
import useStores from '../../hooks/useStores';
import { measurementOptions } from './MeasurementOptions';
import { ReactComponent as MeasurementsIcon } from '../../assets/icons/measurementsIcon.svg';
export default function MeasurementsAction() {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [unit, setMeasurementUint] = useState<number>();
  const { measurementsStore } = useStores();

  useEffect(() => {
    setMeasurementUint(measurementsStore.unitsMapping);
  }, [measurementsStore.unitsMapping]);

  const onChange = (event: any) => {
    // eslint-disable-line
    const unit = event.target.value as number;
    setMeasurementUint(unit);
    measurementsStore.save(unit);
    setIsDialogOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={() => {
          setIsDialogOpen(true);
        }}
        size="large"
      >
        <Tooltip title={'Measurements'}>
          <MeasurementsIcon />
        </Tooltip>
      </IconButton>
      <Dialog
        open={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
      >
        <div className="p-4 pb-8">
          <div className="flex items-center justify-between pb-4">
            <span className="pr-8 font-bold">Measurements</span>
            <IconButton
              size="medium"
              aria-label="close"
              className="p-0 self-center"
              onClick={() => {
                setIsDialogOpen(false);
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
          </div>
          <DialogContent>
            <div>
              <span className="text-neutrals-n-200-600 text-left">Select measurement unit</span>
              <Select
                variant="outlined"
                options={measurementOptions}
                value={unit}
                onChange={(event) => onChange(event)}
                defaultValue={unit}
                className="mt-2"
              />
            </div>
          </DialogContent>
        </div>
      </Dialog>
    </>
  );
}
